export const ROLES = {
  SUPERADMIN: 'superadmin',
  VENDOR: 'vendor',
  CAPTAIN: 'captain',
  WAITER: 'waiter',
  BILLING: 'billing',
};

export const ROLE_LABELS = {
  superadmin: 'Super Admin',
  vendor: 'Vendor Admin',
  captain: 'Captain',
  waiter: 'Waiter',
  billing: 'Billing Staff',
};

export const ORDER_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  PREPARING: 'preparing',
  READY: 'ready',
  SERVED: 'served',
  CANCELLED: 'cancelled',
};

export const PAYMENT_STATUS = {
  UNPAID: 'unpaid',
  PARTIAL: 'partial',
  PAID: 'paid',
};
